import { render, staticRenderFns } from "./AnnouncementsSection.vue?vue&type=template&id=6b387748&"
import script from "./AnnouncementsSection.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports